import React from 'react';
import PropTypes from 'prop-types';
import JobModule from 'modules/job';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import JobHelper from 'utils/jobHelper';
import withRouterHooks from 'utils/routerHelper';

class JobDetailEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCloseModal: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.constant.fetchList());
  }

  _isAllowedToAddTask() {
    const { form } = this.props;
    if (
      Utils.Helper.isNonEmptyString(form.base_task_attributes.address_attributes.country)
        && Utils.Helper.isNonEmptyString(form.base_task_attributes.address_attributes.line_1)
        && Utils.Helper.isNonEmptyString(form.base_task_attributes.time_from)
    ) {
      // Point-to-Point job types have limitations such that only one task is allowed per job
      if (form.job_type === 'p2p') {
        return form.tasks_attributes.length < 1;
      }
      return true;
    }

    return false;
  }

  _getAccountOptions() {
    let accountOptions = [];

    if (this.props.customer && typeof this.props.customer.billing_accounts !== 'undefined') {
      accountOptions = this.props.customer.billing_accounts.map(account => ({
        value: account.id,
        text: account.name,
      }));
    }
    return accountOptions;
  }

  _renderButton() {
    if (this.props.form.tasks_attributes.length > 0) {
      // Can save job after having at least one task
      return (
        <Components.Form.MobileMainButton
          iconClassName="versa-completed"
          id="vf-mobile-job__new-form__job-form__save-button"
          onClick={this.props.save}
        >
          {this.props.strings.Job.form.buttons.save}
        </Components.Form.MobileMainButton>
      );
    }

    if (this._isAllowedToAddTask()) {
      // Can start adding tasks after all required fields are filled up
      return (
        <Components.Form.MobileMainButton
          iconClassName="versa-add"
          id="vf-mobile-job__new-form__job-form__add-task-main-button"
          onClick={() => {
            this.props.setTaskIndex(null);
            this.props.setPage(JobHelper.PageConstants.TASK_DETAIL_EDIT);
          }}
        >
          {this.props.strings.Job.form.buttons.addTask}
        </Components.Form.MobileMainButton>
      );
    }
    // Cannot do anything
    return false;
  }

  render() {
    const accountOptions = this._getAccountOptions();

    return (
      <Components.Form.MobileCoreLayout
        className="vf-job__mobile-new-form__job-detail"
        footer={this._renderButton()}
        header={(
          <Components.Mobile.NavigationBar
            leftButton={Components.Mobile.NavigationBar.buttonConst.CLOSE}
            onLeftButtonClick={() => {
              if (this.props.isChanged) {
                this.setState({ showCloseModal: true });
              } else {
                this.props.navigate('/jobs');
              }
            }}
            title={(
              <Components.Form.MobileTitle>
                <Components.Form.MobileTitle.Item isHighlighted key="title-job-type-info">
                  {this.props.form.job_type === 'pickup'
                    ? this.props.strings.Job.form.menu.jobDeliveryInfo
                    : this.props.strings.Job.form.menu.jobPickupInfo}
                </Components.Form.MobileTitle.Item>
                <Components.Form.MobileTitle.Item key="title-task-type-info">
                  {this.props.form.job_type === 'pickup'
                    ? this.props.strings.Job.form.menu.pickupTaskInfo
                    : this.props.strings.Job.form.menu.deliveryTaskInfo}
                </Components.Form.MobileTitle.Item>
              </Components.Form.MobileTitle>
            )}
          />
        )}
      >
        <JobModule.Edit
          constant={this.props.constant}
          customer={this.props.customer}
          data={this.props.form}
          error={this.props.error}
          form={this.props.form}
          id="vf-mobile-job__new-form__job-form"
          onFormChange={this.props.onFormChange}
          optionAddresses={this.props.optionAddresses}
        />

        <div className="vf-job__detail__tasks">
          {`${(this.props.form.job_type === 'pickup' ? this.props.strings.Job.form.task.pickupTask
            : this.props.strings.Job.form.task.deliveryTask)} (${this.props.form.tasks_attributes.length})`}
          {this._isAllowedToAddTask() ? (
            <Components.Button
              className="vf-job__detail__tasks__button-add"
              iconClassName="versa-add"
              id="vf-mobile-job__new-form__job-form__add-task-button"
              onClick={() => {
                this.props.setTaskIndex(null);
                this.props.setPage(JobHelper.PageConstants.TASK_DETAIL_EDIT);
              }}
            >
              {this.props.strings.Job.form.buttons.addTask}
            </Components.Button>
          ) : false}
        </div>

        {this.props.form.tasks_attributes.map((t, i) => {
          let accountName;
          const account = accountOptions.filter(o => o.value === t.billing_account_id);
          if (account.length > 0) {
            accountName = account[0].text;
          } else {
            accountName = this.props.strings.Task.form.constants.noAccount;
          }

          return (
            // eslint-disable-next-line react/no-array-index-key
            <div className="vf-job__mobile-new-form__job-detail__task-item" key={`task-item-${i}`}>
              <div className="vf-job__mobile-new-form__job-detail__task-item__index">
                {`${i + 1}.`}
              </div>
              <div
                className="vf-job__mobile-new-form__job-detail__task-item__content"
                id="vf-mobile-job__new-form__job-form__view-task-item"
                onClick={() => {
                  this.props.setTaskIndex(i);
                  this.props.setPage(JobHelper.PageConstants.TASK_DETAIL_EDIT);
                }}
              >
                <div className="vf-job__mobile-new-form__job-detail__task-item__content__name">
                  {accountName}
                </div>
                <div className="vf-job__mobile-new-form__job-detail__task-item__content__guid">
                  {t.guid}
                </div>
              </div>
            </div>
          );
        })}
        <Components.Form.CloseConfirmationDialog
          leftButtonOnClick={() => this.props.navigate('/jobs')}
          rightButtonOnClick={() => this.setState({ showCloseModal: false })}
          visible={this.state.showCloseModal}
        />
      </Components.Form.MobileCoreLayout>
    );
  }
}

JobDetailEdit.propTypes = {
  constant: PropTypes.shape({
    jobs: PropTypes.shape(),
  }).isRequired,
  customer: PropTypes.shape({
    billing_accounts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.shape({}),
  form: PropTypes.shape({
    base_task_attributes: PropTypes.shape(),
    job_type: PropTypes.oneOf(['delivery', 'pickup', 'p2p']),
    tasks_attributes: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  isChanged: PropTypes.bool,
  navigate: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
  optionAddresses: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string,
  })).isRequired,
  save: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  setTaskIndex: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      form: PropTypes.shape({
        buttons: PropTypes.shape({
          save: PropTypes.string,
          addTask: PropTypes.string,
        }),
        menu: PropTypes.shape({
          jobDeliveryInfo: PropTypes.string,
          jobPickupInfo: PropTypes.string,
          pickupTaskInfo: PropTypes.string,
          deliveryTaskInfo: PropTypes.string,
        }),
        task: PropTypes.shape({
          pickupTask: PropTypes.string,
          deliveryTask: PropTypes.string,
        }),
      }),
    }),
    Task: PropTypes.shape({
      form: PropTypes.shape({
        constants: PropTypes.shape({
          noAccount: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
};

JobDetailEdit.defaultProps = {
  error: {},
  isChanged: false,
};

const mapStateToProps = (state) => {
  const { profile, constant } = state;
  return {
    constant: constant.constant,
    customer: profile.profile,
    optionAddresses: [],
  };
};

export default withRouterHooks(connect(mapStateToProps)(translate('')(JobDetailEdit)));
